import { Controller } from "@hotwired/stimulus"

// Closes the story dock's "more" <details> menu on outside click or Escape.
export default class extends Controller {
  disconnect() {
    this.unbind()
  }

  toggled() {
    if (this.element.open) {
      this.onDocClick = (event) => {
        if (!this.element.contains(event.target)) this.close()
      }
      this.onKey = (event) => {
        if (event.key === "Escape") {
          this.close()
          this.element.querySelector("summary")?.focus()
        }
      }
      document.addEventListener("click", this.onDocClick)
      document.addEventListener("keydown", this.onKey)
    } else {
      this.unbind()
    }
  }

  close() {
    this.element.open = false
  }

  unbind() {
    if (this.onDocClick) document.removeEventListener("click", this.onDocClick)
    if (this.onKey) document.removeEventListener("keydown", this.onKey)
    this.onDocClick = this.onKey = null
  }
}
